export class DoctorsDayDetailsDto {
    primaryId: string;
    secondaryId: string;
    tertiaryId: string;
    quaternaryId: string;
    dob: string;
    gender: string;
}